export enum ContractType {
  Paper = 'Paper',
  Verified = 'Verified',
  Sms = 'Sms',
  Other = 'Other',
  NotRequired = 'NotRequired',
  NoContract = 'NoContract',
}
